import { dataJobRunTrackerConstants } from "../_constants";
import { dataJobRunTrackerServices } from "../_services";
import { alertActions } from ".";

export const dataJobRunTrackerActions = {
  getAllJobRunTracker,
  getJobRunTrackerById,
  getDataQualityChecks,
  getDataQualityChecksFilter,
  applyDataQualityChecksFilters,
  applyJobRunTrackerFilters
};

function getAllJobRunTracker(workflowId, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices
      .getAllJobRunTracker(workflowId, offset, limit)
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request() {
    return { type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_REQUEST };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_FAILURE,
      error,
    };
  }
}

function getJobRunTrackerById(workflowId, jobRunTrackerId) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices
      .getJobRunTrackerById(workflowId, jobRunTrackerId)
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request() {
    return {
      type: dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_REQUEST,
    };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_JOB_RUN_TRACKER_BY_ID_FAILURE,
      error,
    };
  }
}

function getDataQualityChecks(offset, limit, jobRunTrackerId) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices
      .getDataQualityChecks(offset, limit, jobRunTrackerId)
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request() {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FAILURE,
      error,
    };
  }
}

function getDataQualityChecksFilter(jobRunTrackerId) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices.getDataQualityChecksFilter(jobRunTrackerId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_REQUEST,
    };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FILTER_FAILURE,
      error,
    };
  }
}

function applyDataQualityChecksFilters(
  qualityName,
  columnName,
  offset,
  limit,
  jobRunTrackerId
) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices
      .applyDataQualityChecksFilters(
        qualityName,
        columnName,
        offset,
        limit,
        jobRunTrackerId
      )
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request() {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_DATA_QUALITY_CHECKS_FAILURE,
      error,
    };
  }
}

function applyJobRunTrackerFilters(workflowId, status, startDate, endDate, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    dataJobRunTrackerServices
      .applyJobRunTrackerFilters(workflowId, status, startDate, endDate, offset, limit)
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

   function request() {
    return { type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_REQUEST };
  }
  function success(data) {
    return {
      type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: dataJobRunTrackerConstants.GET_ALL_JOB_RUN_TRACKER_FAILURE,
      error,
    };
  }
}